'use strict'

import React, { useEffect, useState } from 'react'
import { decode } from 'html-entities'
import { eventEmitter } from '../../../../common/baseData'
import ProductPrice from './productPrice/ProductPrice'
import ProductButtons from './productButtons/ProductButtons'

function ProductCard (props) {
  const [inBasket, setInBasket] = useState()

  useEffect(() => {
    // События
    initEvents()
    // Состояние купить / в корзине
    updateState()
  }, [])

  /**
   * Инициализируем события
   */
  function initEvents () {
    eventEmitter.on('basketUpdated', updateState)
  }

  /**
   * Обновляем состояние товара в корзине
   */
  function updateState () {
    setInBasket(productInBasket())
  }

  function productInBasket () {
    let basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}
    return !!basketItemsMap.hasOwnProperty(props.ID)
  }

  /**
   * Событие добавления товара в корзину
   * @param e
   */
  function addToBasket (e) {
    e.preventDefault()
    if (productInBasket()) return
    // отправляется событие добавления в корзину
    eventEmitter.emit('addToCart', { productId: props.ID })
  }

  const stars = () => {
    let stars = []

    for (let i = 1; i <= 5; i++) {
      let starClass = `star-mini ${parseInt(props.BLOG_DATA.RATING) >= i ? 'full' : ''}`
      stars.push(<span className={starClass} key={i}/>)
    }

    return stars
  }

  const properties = () => {
    if (!props.PROPERTIES) return []

    let properties = []

    for (let code in props.PROPERTIES) {
      if (!props.PROPERTIES.hasOwnProperty(code)) continue

      let property = props.PROPERTIES[code]

      if ((props.hasOwnProperty('UF_PR_PROPERTIES') && !props.UF_PR_PROPERTIES.includes(property.ID)) ||
        !property.hasOwnProperty('VALUE') || !property.VALUE.length) continue

      properties.push(<tr key={code}>
        <td className="info-name">{property.NAME}:</td>
        <td className="info-value">
          {
            Array.isArray(property.VALUE) ?
              property.VALUE.join(', ') :
              property.VALUE
          }
        </td>
      </tr>)
    }

    return properties
  }

  const favoriteIcon = () => {
    return <a className="favorite-link" href="#" onClick={event => event.preventDefault()}>
      <i className="icon-favorite" data-container="favorite" data-id={props.ID} data-use="add">
          <span className="tooltip-text">
              <span className="tooltip-text-holder">
                  <span className="tooltip-box">
                      <span>{props.getMessage('ADD_TO_FAVORITE')}</span>
                  </span>
              </span>
          </span>
      </i>
    </a>
  }

  const compareIcon = () => {
    return <a className="comparing-link" href="#" onClick={event => event.preventDefault()}>
      <i className="icon-comparing" data-container="compare" data-id={props.ID} data-use="add">
          <span className="tooltip-text">
              <span className="tooltip-text-holder">
                  <span className="tooltip-box">
                      <span>{props.getMessage('ADD_TO_COMPARE')}</span>
                  </span>
              </span>
          </span>
      </i>
    </a>
  }

  return (
    <div className="product-item">
      {
        props.hasOwnProperty('LABEL') && props.LABEL && props.LABEL.length ?
          <div className="product-label" dangerouslySetInnerHTML={{ __html: props.LABEL }}/> :
          <></>
      }
      {favoriteIcon()}
      {compareIcon()}
      <div className="img">
        <a href={props.DETAIL_PAGE_URL} onClick={event => {
          event.preventDefault()
          props.onClick({...props})
        }}>
          <img src={props.MAIN_PHOTO.src}
               loading={'lazy'}
               alt={decode(props.NAME)}
               height={props.MAIN_PHOTO.height}
               width={props.MAIN_PHOTO.width}/>
        </a>
      </div>
      <div className="product-description">
        <div className="code"><span>{decode(props.ARTICLE)}</span></div>
        <div className="product-name">
          <a href={props.DETAIL_PAGE_URL} onClick={event => {
            event.preventDefault()
            props.onClick({...props})
          }}>{decode(props.NAME)}</a>
        </div>
        {
          props.DISPLAY_PRICE.hasOwnProperty('PRICE') && parseInt(props.DISPLAY_PRICE.PRICE) > 0 ?
            <div className="btn-buy_row">
              <ProductPrice {...props.DISPLAY_PRICE}/>
              <ProductButtons {...props} getMessage={props.getMessage} inBasket={inBasket} onAddToBasket={addToBasket}/>
            </div> :
            <ProductButtons {...props} getMessage={props.getMessage} inBasket={inBasket} onAddToBasket={addToBasket}/>
        }
      </div>
      <div className="hidden-info">
        <div className="hidden-info-holder">
          <div className="rate-row">
            {
              props.BLOG_DATA && props.BLOG_DATA.hasOwnProperty('RATING') ?
                <div className="rate">{stars()}</div> :
                <></>
            }
            <div className="product-reviews">
              {
                props.BLOG_DATA && props.BLOG_DATA.hasOwnProperty('RATING') ?
                  <a href={`${props.DETAIL_PAGE_URL}#section-testimonials`}>
                    {props.BLOG_DATA.MESSAGE}
                  </a> :
                  <>{props.BLOG_DATA.MESSAGE}</>
              }
            </div>
          </div>
          <table className="info-items-list">{properties()}</table>
        </div>
      </div>
    </div>
  )
}

export default ProductCard